import {allBusinessComponents} from "./businessComponent"
import {allBasicComponents} from "./basicComponent"

export default {
  ...allBasicComponents,
  ...allBusinessComponents
}